/** Opções de itens por página das listagens de grupos. */
export const PAGE_SIZES = [10, 25, 50, 100];
